import { WebLayout } from "../components/web-layout";

export function Registered() {
    return (
        <WebLayout hideRegistartionLink>
            <div className="container margin-bottom-30">
                <div className="row  margin-bottom-30">
                    <div className="rounded bg-white-transparent  margin-bottom-30">
                        <h2 className="text-center">Thank You!</h2>
                        <h4 className="text-center">
                            HabitNu will contact you via email to complete your
                            registration
                        </h4>
                    </div>
                </div>
            </div>
        </WebLayout>
    );
}
